"use strict";
var footable = require('footable');

angularFootable.$inject = ['$translate'];
function angularFootable($translate) {
  var events = {
     beforeFiltering: 'footable_filtering'
  };

  var bindEventHandler = function(tableObj, scope, attrs) {
    var k;
    for (k in attrs) {
      if (k !== 'filter' && (!angular.isUndefined(events[k]))) {
        var targetEventName = events[k];
        if (angular.isFunction(scope.$eval(attrs[k]))) {
          tableObj.bind(targetEventName, scope.$eval(attrs[k]));
        }
      }
    }
  };

  return {
    restrict: 'C',
    scope: {
        loadWhen: '='
    },
    link: function(scope, element, attrs) {
      var tableOpts = {
        'event-filtering': null
      };
      angular.extend(
        tableOpts,
        footable.options
      );
      angular.extend(
        tableOpts,
        function(tableOpts, attrs) {
			    var extracted = {},
			        k;
			    for (k in tableOpts) {
			      if (k !== 'filter' && (!angular.isUndefined(events[k]))) {
			          if (!angular.isFunction(scope.$eval(attrs[k]))) {
			            extracted[k] = attrs[k];
			          }
			      }
			    }
			    return extracted;
			  }
      );

      tableOpts.createDetail = function(element, data, createGroupedDetail, separatorChar, classes) {

        var groups = createGroupedDetail(data);
        for (var group in groups) {
          if (groups[group].data.length === 0) {
          	continue;
          }
          if (group !== '_none') {
          	element.append('<div class="' + classes.detailInnerGroup + '">' + groups[group].name + '</div>');
         	}
          for (var j = 0; j < groups[group].data.length; j++) {
            var separator = (groups[group].data[j].name) ? separatorChar : '';
            element.append($('<div></div>').addClass(classes.detailInnerRow).append($('<div></div>').addClass(classes.detailInnerName)
              .append($translate.instant(groups[group].data[j].name) + separator)).append($('<div></div>').addClass(classes.detailInnerValue)
              .attr('data-bind-value', groups[group].data[j].bindName).append(groups[group].data[j].display)));
          }
        }
      };

      tableOpts.calculateWidthOverride = function() {
		    return { width: $(window).width() };
		  };

      var tableObj = {};
      var initTable = function() {
        if (typeof element.footable === 'function') {
            tableObj = element.footable(tableOpts);
        } else {
            tableObj = jQuery(element).footable(tableOpts);
        }
        bindEventHandler(tableObj, scope, attrs);
      };
      if (typeof attrs.loadWhen !== 'undefined') {
        scope.$watch(function() {
            return scope.loadWhen;
        }, function(data) {
            if (typeof data !== 'undefined' && data.length) {
                initTable();
            }
        });
      } else {
        initTable();
      }
    }
  };
}

angular.module('dokiv')
  .directive('footable', angularFootable)
  .directive('fooRepeatDone', function() {
    return function(scope) {
      if (scope.$last) { // all are rendered
          $('.footable').trigger('footable_redraw');
      }
    };
  });


//////////////////
// WEBPACK FOOTER
// ./scripts/app/angular-footable.js
// module id = 257
// module chunks = 0